<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar class="dialog-header gradient-bg" style="color: white;">
        <v-toolbar-title class="white--text headline font-weight-medium">查看</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
            icon
            @click="fullscreen=!fullscreen"
            class="white--text"
        >
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider class="my-0" style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2" color="primary lighten-2"/>

      <v-card-text class="pa-4">
        <v-container grid-list-md class="pa-0">
          <v-layout wrap>
            <v-flex xs12>
              <div class="x-text-field">
                <label>论文标题</label>
                <div>{{item.title}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm10>
              <div class="x-text-field">
                <label>刊物名称</label>
                <div>
                  <span
                    style="color: red"
                    v-if="item.category  === 'J' && !item.journalId"
                  >[目录外]</span>
                  {{item.publication}}
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm2>
              <div class="x-text-field">
                <label>类别</label>
                <div>{{item.category === 'J' ? '期刊':'会议'}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm5>
              <div class="x-text-field">
                <label>校内主管部门</label>
                <div>{{item.adminDept? item.adminDept.name : ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm7>
              <div class="x-text-field">
                <label>检索情况</label>
                <div>{{ (item.indexings || []).map(v => v.name).join(';') }}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>发表时间</label>
                <div>{{(item.publDate || '').substring(0, 7)}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm2>
              <div class="x-text-field">
                <label>卷</label>
                <div>{{item.volume}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm2>
              <div class="x-text-field">
                <label>期</label>
                <div>{{item.number}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>页码</label>
                <div>{{item.pages}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>作者列表</label>
                <div>
                  <v-data-table
                    class="dense"
                    :headers="headers"
                    :items="item.authors"
                    hide-actions
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{props.item.rank}}</td>
                      <td>{{props.item.name}}</td>
                      <td>{{props.item.deptName}}</td>
                      <td>{{props.item.corresponding?'是':''}}</td>
                      <td>{{props.item.coFirst?'是':''}}</td>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>单位署名</label>
                <div>{{(!item.institutionRank || item.institutionRank === 0) ? '未署名': `第${item.institutionRank}单位`}}
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm8>
              <div class="x-text-field">
                <label>归属部门</label>
                <div>{{item.department ? item.department.name : ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>学科分类</label>
                <div>{{ item.subject ? item.subject.name: '' }}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>备注</label>
                <div>{{item.note}}</div>
              </div>
            </v-flex>

            <v-flex
              xs12
              v-if="item.attachments && item.attachments.length > 0"
            >
              <p class="my-1">附件列表：</p>
              <v-divider/>
              <ol>
                <li v-for="a in item.attachments" :key="a.dbid" class="pt-1">
                  <a :href="`/api/papr/file/${a.dbid}`" target="_blank">
                    {{a.fileName}}
                    ({{a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer/>
        <v-btn
            color="primary"
            @click.native="visible=false"
            large
            depressed
            class="confirm-btn"
        >关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/papr/paper';

  export default {
    mixins: [mixin.view(baseUri)],
    data() {
      return {
        item: {},
        headers: [
          {text: '排序', sortable: false, value: 'rank', width: 18},
          {text: '姓名', sortable: false, value: 'name'},
          {text: '单位', sortable: false, value: 'rank'},
          {text: '通迅作者', sortable: false, value: 'coresponding'},
          {text: '共同一作', sortable: false, value: 'coFirst'},
        ],
      }
    }
  }
</script>

<style>

/* 标题栏样式 */
.dialog-header {
  padding: 0 24px !important; /* 去掉上下 padding，改用 height 控制 */
  height: 50px;
  display: flex;
  align-items: center; /* 确保子元素垂直居中 */
}

.gradient-bg {
  background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
}
.detail-field {
  margin-bottom: 16px;
}

.detail-label {
  font-size: 14px;
  color: #616161;
  margin-bottom: 4px;
  display: block;
}

.detail-content {
  font-size: 15px;
  line-height: 1.6;
  word-break: break-word;
}

/* 添加卡片阴影和圆角 */
.v-card {
  border-radius: 8px !important;
}

/* 调整表格样式 */
.v-data-table.dense /deep/ table {
  border-collapse: separate;
  border-spacing: 0;
}

.v-data-table.dense /deep/ th {
  font-weight: 500;
  background-color: #f5f5f5 !important;
}

.v-data-table.dense /deep/ tr:hover {
  background-color: #f5f5f5 !important;
}

/* 调整分隔线颜色 */
.v-divider {
  border-color: rgba(0, 0, 0, 0.08) !important;
}

.confirm-btn {
  min-width: 120px;
  height: 42px;
  border-radius: 6px;
  background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
  color: white !important;
  box-shadow: 0 2px 8px rgba(75, 108, 183, 0.3);
  transition: all 0.3s;
  font-weight: 500;
}

.confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(75, 108, 183, 0.4);
}

.professional-confirm-dialog {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
}

.v-spacer {
  flex-grow: 1;
}

</style>
